import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

const StepControlButton = props => {
  const {
    groups,
    formikProps,
    currentGroup,
    onNextHandler,
    setSubmitPossible,
    isExistingEntry,
  } = props;
  const { isSubmitting, isValid } = formikProps;
  const { forceUpdate } = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const hasTrainer = props.myTrainer.data && props.myTrainer.data.length > 0;
  const buttonIsDisabled = () => {
    if (isExistingEntry) return false;
    return !isValid || isSubmitting;
  };

  let disabled;
  if (currentGroup === 7 && isExistingEntry) {
    disabled = true;
    if (forceUpdate) {
      disabled = false;
    }
  }

  if (!hasTrainer) {
    disabled = false;
  }
  console.log('Disabled?', disabled);
  if (isSubmitting) {
    disabled = true;
  }
  return (
    <div className="position-relative">
      <button
        type="submit"
        className={`btn group-control  btn-primary${
          buttonIsDisabled() ? ' disabled' : ''
        }`}
        disabled={disabled}
        onClick={e => {
          if (isValid || isExistingEntry) {
            if (currentGroup === 7) {
              // We manually submit this with the formikProps because the submit binding doesn't work on mobile for some very confusing reason
              e.preventDefault();
              setSubmitPossible(formikProps);
            } else {
              onNextHandler(formikProps);
            }
          }
        }}
      >
        {currentGroup !== 7
          ? `NEXT STEP : ${groups[currentGroup].caption}`
          : 'SUBMIT ONBOARDING'}
      </button>
      {currentGroup === 7 && isExistingEntry && !forceUpdate && hasTrainer && (
        <span className="complete-required-custom">
          Already completed! Talk to your coach if you need to update any
          information.
        </span>
      )}
      {buttonIsDisabled() && (
        <span className="complete-required-custom">
          *Please complete all required questions
        </span>
      )}
    </div>
  );
};

StepControlButton.propTypes = {
  groups: PropTypes.array.isRequired,
  myTrainer: PropTypes.object.isRequired,
  formikProps: PropTypes.object.isRequired,
  currentGroup: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
  onNextHandler: PropTypes.func.isRequired,
  setSubmitPossible: PropTypes.func.isRequired,
  isExistingEntry: PropTypes.bool.isRequired,
};

export default withRouter(StepControlButton);
